import { useState } from "react";
import { useAuth } from "@/context/auth-context";
import Navbar from "@/components/application/components/Navbar";
import ProfileHeader from "@/components/application/profile/ProfileHeader";
import AvatarCustomizationModal from "@/components/application/profile/AvatarCustomizationModal";
// import StatsOverview from "@/components/application/profile/StatsOverview"
import ActivityHistory from "@/components/application/profile/ActivityHistory";
// import Achievements, { defaultAchievements } from "@/components/application/profile/Achievements"
import { useUserActivities } from "@/queries/profileQueries";

const Profile = () => {
  const { user } = useAuth();
  const [showAvatarModal, setShowAvatarModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  // Fetch user data
  const { data: activitiesData, isLoading: activitiesLoading } =
    useUserActivities( currentPage, 10);
  // const { data: achievements, isLoading: achievementsLoading } = useUserAchievements(user?.id || "")

  if (!user) {
    return null;
  }

  // Show loading state with DaisyUI skeleton
  if (activitiesLoading) {
    return (
      <div className="min-h-screen bg-base-200">
        <Navbar />
        <div className="container mx-auto px-4 pt-24 pb-8 max-w-5xl">
          {/* Loading Skeleton */}
          <div className="skeleton h-64 w-full mb-6"></div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="skeleton h-32 w-full"></div>
            ))}
          </div>
          <div className="skeleton h-96 w-full mb-6"></div>
          <div className="skeleton h-64 w-full"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-base-200">
      <Navbar />

      {/* Hero Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5 pointer-events-none"></div>

      <div className="relative container mx-auto px-4 pt-24 pb-8 max-w-5xl">
        {/* Profile Header */}
        <div className="mb-12 mt-8">
          <ProfileHeader
            user={user}
            onEditAvatar={() => setShowAvatarModal(true)}
          />
        </div>

        {/* Quiz History */}
        <ActivityHistory
          data={activitiesData}
          isLoading={activitiesLoading}
          onPageChange={setCurrentPage}
        />
      </div>

      {/* Avatar Customization Modal */}
      <AvatarCustomizationModal
        isOpen={showAvatarModal}
        onClose={() => setShowAvatarModal(false)}
      />
    </div>
  );
};

export default Profile;
